
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thanks",
      function () {
        return require("private-next-pages/thanks.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thanks"])
      });
    }
  